<script>
import { toPadding } from "@shared/block-ratio"

export default {
  functional: true,

  props: {
    spaceXRatio: { type: Number, default: 0 },
    spaceTopRatio: { type: Number, default: 0 },
    spaceBottomRatio: { type: Number, default: 0 }
  },

  render(h, { props, scopedSlots }) {
    const padding = toPadding(
      props.spaceTopRatio,
      props.spaceXRatio,
      props.spaceBottomRatio
    )

    return scopedSlots.default({ padding })
  }
}
</script>
